/**
 * Plan API access matrix — mirrors backend planFeatureAuth / apiLimits rules.
 */

const PLAN_API_FEATURES = [
  { id: "snapshot_all", label: "Snapshot — All Currency Pairs" },
  { id: "snapshot_single", label: "Snapshot — Single Symbol" },
  { id: "snapshot_multi", label: "Snapshot — Multi-Symbol" },
  { id: "previous_close", label: "Previous Close API" },
  { id: "aggregate", label: "Aggregate (OHLC) Data" },
  { id: "currency_conversion", label: "Currency Conversion API" },
  { id: "reference_rates", label: "RBI Reference & Customs Rates" },
  { id: "rbi_historical", label: "RBI Historical Rates" },
  { id: "dxy", label: "DXY Index API" },
  { id: "technical_indicators", label: "Technical Indicators" },
  { id: "forward_rates", label: "Forward Rate APIs (add-on)" },
  { id: "websocket_snapshot", label: "WebSocket Live Snapshot" },
  { id: "data_updates_60s", label: "60 Second Data Updates" },
  { id: "data_updates_realtime", label: "Real-Time Data Updates" },
];

const PLAN_ACCESS = {
  FREE: {
    snapshot_all: true,
    snapshot_single: true,
    snapshot_multi: true,
    previous_close: false,
    aggregate: false,
    currency_conversion: false,
    reference_rates: false,
    rbi_historical: false,
    dxy: false,
    technical_indicators: false,
    forward_rates: false,
    websocket_snapshot: false,
    data_updates_60s: true,
    data_updates_realtime: false,
  },
  BASIC: {
    snapshot_all: true,
    snapshot_single: true,
    snapshot_multi: true,
    previous_close: true,
    aggregate: true,
    currency_conversion: true,
    reference_rates: false,
    rbi_historical: true,
    dxy: false,
    technical_indicators: false,
    forward_rates: false,
    websocket_snapshot: false,
    data_updates_60s: true,
    data_updates_realtime: false,
  },
  ESSENTIAL: {
    snapshot_all: true,
    snapshot_single: true,
    snapshot_multi: true,
    previous_close: true,
    aggregate: true,
    currency_conversion: true,
    reference_rates: true,
    rbi_historical: true,
    dxy: true,
    technical_indicators: false,
    forward_rates: false,
    websocket_snapshot: false,
    data_updates_60s: true,
    data_updates_realtime: false,
  },
  PRO: {
    snapshot_all: true,
    snapshot_single: true,
    snapshot_multi: true,
    previous_close: true,
    aggregate: true,
    currency_conversion: true,
    reference_rates: true,
    rbi_historical: true,
    dxy: true,
    technical_indicators: false,
    forward_rates: false,
    websocket_snapshot: true,
    data_updates_60s: false,
    data_updates_realtime: true,
  },
  ULTIMATE: {
    snapshot_all: true,
    snapshot_single: true,
    snapshot_multi: true,
    previous_close: true,
    aggregate: true,
    currency_conversion: true,
    reference_rates: true,
    rbi_historical: true,
    dxy: true,
    technical_indicators: true,
    forward_rates: false,
    websocket_snapshot: true,
    data_updates_60s: false,
    data_updates_realtime: true,
  },
};

export function formatPlanApiCallsLabel(planBackendName, apiCalls) {
  if (String(planBackendName || "").toUpperCase() === "FREE") {
    return "100 API Requests for a month";
  }
  const n = Number(apiCalls);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `${n.toLocaleString()} API Requests/month`;
}

export function planHasFeature(planBackendName, featureId) {
  const key = String(planBackendName || "").toUpperCase();
  if (!key || key === "NONE") return false;
  const access = PLAN_ACCESS[key];
  if (!access) return false;
  return Boolean(access[featureId]);
}

export function getPlanApiAccessItems(planBackendName) {
  const key = String(planBackendName || "").toUpperCase();
  const access = PLAN_ACCESS[key] || PLAN_ACCESS.FREE;

  return PLAN_API_FEATURES.map((feature) => {
    let label = feature.label;
    if (feature.id === "websocket_snapshot" && access.websocket_snapshot) {
      label =
        key === "ULTIMATE"
          ? "WebSocket Live Snapshot (5 connections)"
          : "WebSocket Live Snapshot (2 connections)";
    }
    if (
      feature.id === "forward_rates" &&
      (key === "PRO" || key === "ULTIMATE")
    ) {
      label = "Forward Rate APIs (optional add-on at checkout)";
    }
    return {
      id: feature.id,
      label,
      included: Boolean(access[feature.id]),
    };
  });
}
